import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/core/services/shared.service';
import { FiltrosPersistenciaService } from 'src/app/core/services/filtros-persistencia.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-custom',
  templateUrl: './modal-custom.component.html',
  styleUrls: ['./modal-custom.component.scss']
})
export class ModalCustomComponent{

  @Input() sedes = [];
  @Input() periodos = [];
  @Input() carreras = [];
  @Input() sedeSeleccionada = null;
  @Input() periodoSeleccionado = null;
  @Input() M04IUP = null;

  @Input() anios = [];
  @Input() M05COD = null;
  @Input() M18COD = null;
  @Input() M19COD = null;

  @Input() companias = [];
  @Input() CNT05COD = null;
  @Input() MostrarFiltroPrincipal = null;
  @Input() ModuloDefault = null
  @Input() MenuModulo = [];

  @Input() origen = null;


  @Output() retornoSeleccionado = new EventEmitter();
  @Output() cambioPeriodos = new EventEmitter<string>();
  @Output() cambioCarreras = new EventEmitter<string>();

  strMenuSedesPorCopania: string = "api/servicios/SeleccionarSedePorCompania";
  CNT05CODAux : String = "";
  M05CODAux : String = "";
  // almora 2026.05.09 — auxiliares para que cancelar el modal NO altere los globales del padre
  M18CODAux : any = null;
  M19CODAux : any = null;

  constructor(public activeModal: NgbActiveModal, private dataService: SharedService, private filtrosPersistencia: FiltrosPersistenciaService) {

  }

  ngOnInit(): void {
    // se inicializan los auxiliares
    this.CNT05CODAux = this.CNT05COD;
    this.M05CODAux = this.M05COD;
    this.M18CODAux = this.M18COD;
    this.M19CODAux = this.M19COD;
    // se inicializa Mostrar Filtros
    this.MostrarFiltroPrincipal = this.MostrarFiltroPrincipal == null || this.MostrarFiltroPrincipal == "null" ? 'false' : this.MostrarFiltroPrincipal;
  }

  // almora 2026.05.09 — Para origen=3 (header). Emite el cambio de M18 al caller para que recargue periodos.
  cambiarPeriodosAux(anio: any) {
    // anio viene como objeto del ng-select (bindLabel=M18DES, sin bindValue) o como string si bindValue=M18COD
    const m18 = (anio && anio.M18COD !== undefined) ? anio.M18COD : anio;
    this.M19CODAux = null; // reset M19 al cambiar M18
    this.cambioPeriodos.emit(m18);
  }
  cambiarPeriodos(anio){  
    this.cambioPeriodos.emit(anio.M18COD);
  }

  cambiarCarreras(sede){
    this.cambioCarreras.emit(sede.M05COD);
  }

  guardarConfiguracion(){
    let M05DES, CNT05DES, CNT05DOM = '';
    switch (this.origen) {
      case 1:
        localStorage.setItem("sede", JSON.stringify(this.sedeSeleccionada));
        localStorage.setItem("periodo", JSON.stringify(this.periodoSeleccionado));
        localStorage.setItem("M04IUP", this.M04IUP);
        break;
      case 2:
        let strsSede = '';
        for (const key in this.sedes) {
          if (this.sedes[key].M05COD == this.M05COD) {
            strsSede = this.sedes[key].M05DES;
            break;
          }
        }
        localStorage.setItem("M05COD", this.M05COD);
        localStorage.setItem("M18COD", this.M18COD);
        localStorage.setItem("M19COD", this.M19COD);
        localStorage.setItem("strSede", strsSede);
        break;
      case 3:

        // Se genera el cambio a auxiliares M05CODAux - CNT05CODAux
        
        if (this.M05CODAux != null || this.CNT05CODAux != null) {
          for (const key in this.sedes) {
            if (this.sedes[key].M05COD == this.M05CODAux) {
              M05DES = this.sedes[key].M05DES;
              break;
            }
          }
          for (const key in this.companias) {
            if (this.companias[key].CNT05COD == this.CNT05CODAux) {
              CNT05DES = this.companias[key].CNT05DES;
              CNT05DOM = this.companias[key].CNT05DOM;
              break;
            }
          }

          // se valida si el dominio seleccionado
          const url = new URL(CNT05DOM);
          const dominio =  window.location.host;
          if(dominio != url.host){
            window.open(CNT05DOM, '_blank');
            return;
          }
  
          // almora 2026.05.09 — limpia particulares y resetea globales con los 4 valores
          const m18Str = (this.M18CODAux == null) ? '' : String(this.M18CODAux);
          const m19Str = (this.M19CODAux == null) ? '' : String(this.M19CODAux);
          this.filtrosPersistencia.cambiarContextoHeader(this.CNT05CODAux.toString(), this.M05CODAux.toString(), m18Str, m19Str);
          localStorage.setItem("X-AVATAR-CNT05COD",this.CNT05CODAux.toString());
          localStorage.setItem("X-AVATAR-M05COD",this.M05CODAux.toString())
          localStorage.setItem("X-AVATAR-CNT05DES", CNT05DES);
          localStorage.setItem("X-AVATAR-M05DES", M05DES)
          
          localStorage.setItem("X-AVATAR-MOSTRARFILTRO",this.MostrarFiltroPrincipal)    
          localStorage.setItem("X-AVATAR-MODULODEFAULT",this.ModuloDefault)    
        }else{
          Swal.fire({
            title: 'Error',
            text: 'Debe ingresar la Sede y Compañía',
            icon: 'error',
          });
        }
        break;
      case 4:
        if (this.M05COD != null || this.CNT05COD != null) {
          for (const key in this.sedes) {
            if (this.sedes[key].M05COD == this.M05COD) {
              M05DES = this.sedes[key].M05DES;
              break;
            }
          }
          for (const key in this.companias) {
            if (this.companias[key].CNT05COD == this.CNT05COD) {
              CNT05DES = this.companias[key].CNT05DES;
              CNT05DOM = this.companias[key].CNT05DOM;
              break;
            }
          }

          // se valida si el dominio seleccionado
          const url = new URL(CNT05DOM);
          const dominio =  window.location.host;
          if(dominio != url.host){
            window.open(CNT05DOM, '_blank');
            return;
          }
  
          // almora 2026.05.09 — limpia particulares y resetea globales si cambia la sede/compañia
          this.filtrosPersistencia.cambiarContextoHeader(this.CNT05COD, this.M05COD);
          localStorage.setItem("X-AVATAR-CNT05COD",this.CNT05COD);
          localStorage.setItem("X-AVATAR-M05COD",this.M05COD)
          localStorage.setItem("X-AVATAR-CNT05DES", CNT05DES);
          localStorage.setItem("X-AVATAR-M05DES", M05DES)
           
        }else{
          Swal.fire({
            title: 'Error',
            text: 'Debe ingresar la Sede y Compañía',
            icon: 'error',
          });
        }
        break;
    }

    this.retornoSeleccionado.emit();
    this.activeModal.close();
  }

  cambiarSede(CNTO5COD: String){
    let data = {
      LLAVES: [{CNT05COD:CNTO5COD}]
    };

    this.dataService.Ejecutar(this.strMenuSedesPorCopania, JSON.stringify(data)).subscribe((datosResp6: any) => {
      this.sedes = [];
      this.M05CODAux = CNTO5COD == this.CNT05COD ? this.M05COD : "";
      this.sedes = datosResp6[0].SEDES;
    })
  }
}
